import { render, staticRenderFns } from "./UserCRUD.vue?vue&type=template&id=64b9005d&scoped=true"
import script from "./UserCRUD.vue?vue&type=script&lang=js"
export * from "./UserCRUD.vue?vue&type=script&lang=js"
import style0 from "./UserCRUD.vue?vue&type=style&index=0&id=64b9005d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b9005d",
  null
  
)

export default component.exports